import React from "react";
import { Row, Col, Label, Input, Button, Card, CardBody } from "reactstrap";
import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";

const ConnectorList = ({
  values,
  setFieldValue,
  isEdit = false,
  isView = false,
}) => {
  const connectors = values?.connectors?.length
    ? values.connectors
    : [
        {
          connectorId: "",
          connectorType: "",
          powerKw: "",
          connectorStatus: "",
          timestamp: "",
        },
      ];

  const addConnector = () => {
    setFieldValue("connectors", [
      ...connectors,
      {
        connectorId: "",
        connectorType: "",
        powerKw: "",
        connectorStatus: "",
        timestamp: "",
        isExistingConnector: false,
      },
    ]);
  };

  const removeConnector = (index) => {
    setFieldValue(
      "connectors",
      connectors.filter((_, i) => i !== index),
    );
  };

  const updateConnector = (index, field, value) => {
    setFieldValue(`connectors[${index}].${field}`, value);
  };

  return (
    <Card className="border rounded-1 mt-3">
      <CardBody>
        <Row className="align-items-center mb-3">
          <Col>
            <h5 className="mb-0">Connector</h5>
          </Col>

          {/* {!isView && (
            <Col xs="auto">
              <Button
                type="button"
                color="main-color"
                className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1"
                onClick={addConnector}
              >
                <i className="ri-add-line label-icon align-middle fs-16 me-2"></i>
                <span className="px-2 fw-bold">Add Connector</span>
              </Button>
            </Col>
          )} */}
        </Row>

        {connectors.length === 0 && (
          <p className="text-muted mb-0">
            No connectors added. Click Add Connector to add connector details.
          </p>
        )}

        {connectors.map((connector, index) => (
          <div
            key={connector.id ?? `connector-${index}`}
            className="border rounded p-3 mb-3"
          >
            <Row className="align-items-center mb-3">
              <Col>
                <h6 className="mb-0">Connector {index + 1}</h6>
              </Col>

              {/* {!isView && (
                <Col xs="auto">
                  <Button
                    type="button"
                    color="danger"
                    outline
                    size="sm"
                    onClick={() => removeConnector(index)}
                  >
                    Remove
                  </Button>
                </Col>
              )} */}
            </Row>

            <Row className="gy-3">
              {/* Connector ID */}
              <Col lg={3} md={6}>
                <LabelText
                  htmlFor={`connectors[${index}].connectorId`}
                  displayText="Connector ID"
                />
                <LabelText
                  htmlFor={`connectors[${index}].connectorId`}
                  classLabelName="d-block ms-0 rv-sub-label rv-label-muted"
                  displayText="Enter Connector ID"
                />
                <Input
                  id={`connectors[${index}].connectorId`}
                  name={`connectors[${index}].connectorId`}
                  type="number"
                  min="0"
                  value={connector.connectorId ?? ""}
                  disabled={isView || Boolean(connector.isExistingConnector)}
                  onChange={(e) =>
                    updateConnector(index, "connectorId", e.target.value)
                  }
                />
              </Col>

              {/* Connector Type */}
              <Col lg={3} md={6}>
                <LabelText
                  htmlFor={`connectors[${index}].connectorType`}
                  displayText="Connector Type"
                />
                <LabelText
                  htmlFor={`connectors[${index}].connectorType`}
                  classLabelName="d-block ms-0 rv-sub-label rv-label-muted"
                  displayText="Enter Connector Type"
                />

                <Input
                  id={`connectors[${index}].connectorType`}
                  name={`connectors[${index}].connectorType`}
                  type="text"
                  value={connector.connectorType ?? ""}
                  disabled={isView}
                  onChange={(e) =>
                    updateConnector(index, "connectorType", e.target.value)
                  }
                />
              </Col>

              {/* Power */}
              <Col lg={3} md={6}>
                <LabelText
                  htmlFor={`connectors[${index}].powerKw`}
                  displayText="Power (in KW)"
                />
                <LabelText
                  htmlFor={`connectors[${index}].powerKw`}
                  classLabelName="d-block ms-0 rv-sub-label rv-label-muted"
                  displayText="Enter Power (in KW)"
                />

                <Input
                  id={`connectors[${index}].powerKw`}
                  name={`connectors[${index}].powerKw`}
                  type="number"
                  min="0"
                  step="any"
                  value={connector.powerKw ?? ""}
                  disabled={isView}
                  onChange={(e) =>
                    updateConnector(index, "powerKw", e.target.value)
                  }
                />
              </Col>
            </Row>
          </div>
        ))}
      </CardBody>
    </Card>
  );
};

export default ConnectorList;
